import {
  PutSupplierHearingStatusItemReqParams,
  PutSupplierHearingStatusItemRes
} from '@gateway.Supplier'
import { yamadumiApi } from '../yamadumi-api'

/**
 * PUT /api/supplier/hearing/status/itemのゲートウェイクラス
 */
export class PutSupplierHearingStatusItemGateway {
  /** 業者ヒアリング-更新 */
  static putHearingStatusItem = async (
    params: PutSupplierHearingStatusItemReqParams
  ) => {
    return await yamadumiApi.put<PutSupplierHearingStatusItemRes>(
      '/api/supplier/hearing/status/item',
      params
    )
  }
}
